import React from 'react';

interface LoadingProps {
}

const LoadingWhite: React.FC<LoadingProps> = () => {
    return (
        <div className="loading-container">
            <div className="loading-spinner"></div>
        </div>
    );
};

export default LoadingWhite;
